import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AADHeader from "./components/AADHeader.js";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const ComingSoonForms = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [loading, setLoading] = useState(false);

  const pageTitles = {
    "/coming-soon": "Business travel",
    "/coming-soon-eol": "End-of-life management",
    "/coming-soon-logistics": "Logistics",
    "/coming-soon-packaging": "Packaging composition",
  };

  const pageTitle = pageTitles[location.pathname] || "Coming Soon";
  const handleNotifyMe = () => {
    Swal.fire({
      icon: "success",
      title: "Request received",
      text: "Thanks! We will notify you when this module is available.",
      confirmButtonColor: "#407775",
    });
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={`${isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"} coming-soon-page-bg`}>
        <div className="container formpd">
          <div className="flex justify-content-between align-items-center">
            <div className="steps__containt-hader">
              <h1 className="title">{pageTitle}</h1>
              <div role="presentation">
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                  <Typography color="text.primary" style={{ cursor: "pointer" }} onClick={() => navigate("/forms-apps")}>
                    Forms & Apps
                  </Typography>
                  <Typography color="text.primary">{pageTitle}</Typography>
                </Breadcrumbs>
              </div>
            </div>
          </div>
          <div className="coming-soon-wrap">
            <div className="coming-soon-card">
              <div className="coming-soon-image-panel">
                <img className="coming-soon-image" src="/assets/img/coming-soon.webp" alt="Module under development" />
              </div>
              <h2 className="coming-soon-title">Module Under Development</h2>
              <p className="coming-soon-subtext">
                We are currently assembling this part of the system.
                <br />
                Check back soon for powerful new features and capabilities.
              </p>
              <div className="coming-soon-actions">
                <button type="button" className="coming-soon-btn coming-soon-btn-primary" onClick={handleNotifyMe}>
                  Notify Me
                </button>
                <button type="button" className="coming-soon-btn coming-soon-btn-secondary" onClick={() => navigate("/forms-apps")}>
                  Go Back to Forms Apps
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonForms;
